<template>
  <div class="keyboard">
    <c-toolbar type="65Fluffy" />
    <div class="fixed-panel px">
      <div class="keyboard-panel">
        <c-keyboard-65-fluffy
          class="c-keyboard"
          :layer="layer"
          :layerIndex="layerIndex"
          :selectedIndex="selectedIndex"
          @key-click="onKeyClick"
        />
      </div>
      <div class="radio-panel">
        <a-radio-group v-model="layerIndex" size="large">
          <a-radio-button
            v-for="index in layerNum"
            :key="index"
            :value="index - 1"
          >
            {{ index === 1 ? $t("keyboard.layer") + " " + index : index }}
          </a-radio-button>
        </a-radio-group>
        <a-radio-group
          :value="system"
          @change="onSystemChange"
          class="radio-group"
          size="large"
          v-if="isTest"
        >
          <a-radio-button :key="0" :value="0">
            Windows
          </a-radio-button>
          <a-radio-button :key="1" :value="1">
            mac
          </a-radio-button>
        </a-radio-group>
        <a-radio-group class="virtual-radio" v-model="type" size="large">
          <a-radio-button key="keymap" value="keymap">
            {{ $t("keymap") }}
          </a-radio-button>
          <a-radio-button key="press&hold" value="press&hold">
            {{ $t("press&hold") }}
          </a-radio-button>
          <a-radio-button key="macro" value="macro">
            {{ $t("macro") }}
          </a-radio-button>
          <a-radio-button key="light" value="light" v-if="isTest">
            {{ $t("light.name") }}
          </a-radio-button>
          <a-radio-button key="reset" value="reset" @click="onReset">
            {{ $t("reset") }}
          </a-radio-button>
          <a-radio-button key="upload" value="upload" for="file">
            <a-tooltip>
              <template slot="title">
                <span style="color: #fff;">{{ $t("downloadTip") }}</span>
              </template>
              {{ $t("download") }}
            </a-tooltip>
            <input
              id="file"
              type="file"
              @change="onUpload"
              accept=".json"
              @click="type = 'upload'"
            />
          </a-radio-button>
          <a-radio-button key="download" value="download" @click="onDownload">
            <a-tooltip>
              <template slot="title">
                <span style="color: #fff;">{{ $t("saveTip") }}</span>
              </template>
              {{ $t("save") }}
            </a-tooltip>
          </a-radio-button>
        </a-radio-group>
      </div>
    </div>
    <div class="virtual-keyboard-panel">
      <c-virtual-keyboard-65-fluffy
        class="c-virtual-keyboard"
        v-if="type === 'keymap'"
        :selectedKey="layer[selectedKeyIndex]"
        :layerNum="layerNum"
        @key-click="onVirtualKeyClick"
      />
      <c-press-hold
        v-if="type === 'press&hold'"
        :dispatchType="'profile65Fluffy/setData'"
        :profile="profile65Fluffy"
        :selectedKey="layer[selectedKeyIndex]"
        :selectedKeyIndex="selectedKeyIndex"
        :layerIndex="layerIndex"
        :pressKeys="pressKeys"
        :holdKeys="holdKeys"
        @key-click="onVirtualKeyClick"
      />
      <c-macro
        v-if="type === 'macro'"
        :dispatchType="'profile65Fluffy/setData'"
        :profile="profile65Fluffy"
        :selectedKey="layer[selectedKeyIndex]"
        :selectedKeyIndex="selectedKeyIndex"
        :layerIndex="layerIndex"
        :keys="basicKeys"
        @key-click="onVirtualKeyClick"
      />
      <c-light-65-fluffy v-if="type === 'light'" />
    </div>
    <div class="in-switch-led">
      <div class="item" @click="goInSwitchLED" v-if="!inLoader">
        <i class="iconfont iconarrow-right" />
        <div v-html="$t('keyboard.inSwitchLED')"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { download, deepCopy } from "@/utils";
import {
  pressKeys,
  holdKeys,
  basicKeys,
} from "./components/VirtualKeyboard65Fluffy";
import { anyKeys } from "@/components/SpecialKeys";

export default {
  name: "Keyboard65Fluffy",
  data() {
    return {
      system: 0,
      layerIndex: 0,
      selectedIndex: -2,
      selectedKeyIndex: null,
      type: "keymap",
      pressKeys,
      holdKeys,
      basicKeys,
    };
  },
  computed: {
    ...mapState("app", {
      isTest: "isTest",
    }),
    ...mapState("loader", {
      inLoader: "inLoader",
      currentDevice: "currentDevice",
    }),
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState(["profile65Fluffy"]),
    layer() {
      return this.profile65Fluffy.data.key_layer.layer_data[this.layerIndex]
        .layer;
    },
    layerNum() {
      return this.profile65Fluffy.data.key_layer.layer_num;
    },
  },
  methods: {
    onSystemChange(e) {
      this.system = e.target.value;
      this.$store.dispatch("loader/setKeySystem", {
        setSystemMode: this.system,
      });
    },
    onKeyClick({ index, keyIndex }) {
      this.selectedKeyIndex = this.selectedIndex === index ? null : keyIndex;
      this.selectedIndex = this.selectedIndex === index ? -1 : index;
    },
    onVirtualKeyClick(key) {
      if (this.layer[this.selectedKeyIndex] === key) return;
      const selectedKey = this.layer[this.selectedKeyIndex];
      if (anyKeys.includes(selectedKey)) {
        let data = this.profile65Fluffy.data;
        const index = data.tab_key.findIndex(
          (k) => k.ph_key_data === selectedKey
        );
        if (index > -1) {
          data.tab_key.splice(index, 1);
          this.$store.dispatch("profile65Fluffy/setData", data);
        }
      }
      let data = deepCopy(this.profile65Fluffy.data);
      let layer = [...this.layer];
      layer[this.selectedKeyIndex] = key;
      data.key_layer.layer_data[this.layerIndex].layer = layer;
      this.$store.dispatch("profile65Fluffy/setData", data);
    },
    onReset() {
      this.$confirm({
        title: this.$t("keyboard.reset"),
        okText: this.$t("yes"),
        cancelText: this.$t("cancel"),
        centered: true,
        onOk: () => {
          if (this.inLoader) {
            this.$store.dispatch("loader/setLoading", true);
            this.$store.dispatch("loader/resetJSON");
          } else {
            this.$store.dispatch("profile65Fluffy/setData", {
              ...this.profile65Fluffy.data,
              key_layer: deepCopy(this.profile65Fluffy.default.key_layer),
              tab_key: deepCopy(this.profile65Fluffy.default.tab_key),
              macro_key: deepCopy(this.profile65Fluffy.default.macro_key),
            });
          }
        },
      });
    },
    onUpload(e) {
      const file = e.target.files[0];
      if (file) {
        new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.onerror = reject;
          fileReader.onload = (e) => {
            try {
              const data = JSON.parse(e.target.result);
              if (
                data &&
                data.product_info &&
                data.product_info.product_id === "FLUFFY"
              ) {
                resolve(data);
              } else {
                reject();
              }
            } catch (error) {
              reject(error);
            }
          };
          fileReader.readAsText(file);
        })
          .then((data) => {
            this.layerIndex = 0;
            this.$store.dispatch("profile65Fluffy/setData", data);
            this.$store.dispatch(
              "profile65Fluffy/setFileName",
              file.name.split(".")[0]
            );
            this.$store.dispatch("loader/syncMacroKey", {
              macro_key: data.macro_key,
              original_key: "",
            });
            e.target.value = null;
          })
          .catch(() => {
            e.target.value = null;
            this.$info({
              title: this.$t("index.fileErrorInfo"),
              width: "8.4rem",
              okText: this.$t("yes"),
              cancelText: this.$t("cancel"),
              centered: true,
            });
          });
      }
    },
    onDownload() {
      const data = deepCopy(this.profile65Fluffy.data);
      const fileName = (
        this.profile65Fluffy.fileName + "-PETBRICK65.json"
      ).replace(/-65.+65/, "-65");
      if (this.inLoader) {
        data.page_num = 0;
        data.page_data = [];
        this.$store.dispatch("loader/downloadFile", {
          name: fileName.replace("-PETBRICK65.json", "-PETBRICK65-KEY.json"),
          json: data,
        });
      } else {
        const file = new Blob([JSON.stringify(data)]);
        download(file, fileName);
      }
    },
    goInSwitchLED() {
      this.$router.push(this.$paths.inSwitchLED65Fluffy);
    },
    goLight() {
      this.$router.push(this.$paths.light65Fluffy);
    },
    goSplit() {
      this.$router.push(this.$paths.keyboard65FluffySplit);
      if (this.inLoader) {
        this.$store.dispatch("loader/setLoading", true);
        setTimeout(() => {
          this.$store.dispatch("loader/syncJSON");
        }, 500);
      }
    },
  },
  watch: {
    layerIndex(index) {
      if (index === 1 && [0, 20].includes(this.selectedIndex)) {
        this.selectedIndex = -1;
        this.selectedKeyIndex = null;
      }
    }
  },
  mounted() {
    this.$store.dispatch("loader/getKeySystem", {
      currentPort: this.currentDevice.port,
    });

    window.upSys = (json) => {
      if (json) {
        console.log("upSys", json);
        const data = JSON.parse(json);
        this.system = data.currentSystemMode;
        console.log("upSys", "true");
      }
    };
  },
};
</script>
<style lang="scss" scoped>
.keyboard {
  min-height: inherit;
  text-align: center;
  color: #ffffff;

  .fixed-panel.px {
    width: 100%;
    background: #171717;
    padding: $header-height + 20px 0 20px 0;
    position: fixed;
    z-index: 1;
    top: 0;
  }

  .keyboard-panel {
    @include flex-center;
    margin-top: -60px;
    margin-bottom: 20px;

    .c-keyboard {
      width: 1520px;
    }
  }

  .radio-panel {
    @include flex-center;
    width: 1300px;
    margin: 0 auto 0 auto;
    justify-content: space-between;
    white-space: nowrap;

    .virtual-radio {
      #file {
        display: none;
      }
    }
  }

  .virtual-keyboard-panel {
    @include flex-center;
    margin-top: calc(800px - 7.5vw);
    margin-bottom: 60px;
    position: relative;
    z-index: 0;

    .c-virtual-keyboard {
      width: 1320px;
    }
  }

  .in-switch-led {
    position: fixed;
    right: 20px;
    bottom: 200px;
    font-size: 20px;

    .item {
      @include flex-center;
      justify-content: flex-start;
      width: 200px;
      cursor: pointer;

      + .item {
        margin-top: 20px;
      }

      &:hover {
        color: $primary-color;
      }
    }

    i {
      width: 54px;
      height: 54px;
      line-height: 54px;
      display: block;
      background: $primary-color;
      color: #ffffff;
      border-radius: 10px;
      margin-right: 20px;
      font-size: 22px;
      padding-left: 5px;
      text-align: center;
    }
  }
}
</style>
